import { useState, useEffect } from 'react';
import { apiService } from '../services/api.service';

export interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export function useAuth() {
  const [authState, setAuthState] = useState<AuthState>({
    token: null,
    isAuthenticated: false,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    initializeAuth();
  }, []);

  const initializeAuth = () => {
    try {
      // 1. Try to get token from URL first
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get('token');

      // 2. Try to get token from localStorage as fallback
      const storedToken = apiService.getToken() || localStorage.getItem('interview_jwt_token');

      const finalToken = tokenFromUrl || storedToken;

      if (finalToken) {
        // Store/Sync token
        apiService.setToken(finalToken);
        
        // Only clean URL if we actually got the token FROM the URL
        if (tokenFromUrl) {
          const newUrl = window.location.pathname + window.location.search.replace(/[?&]token=[^&]+/, '').replace(/^&/, '?');
          window.history.replaceState({}, document.title, newUrl === '' ? '/' : newUrl);
        }

        setAuthState({
          token: finalToken,
          isAuthenticated: true,
          isLoading: false,
          error: null,
        });
      } else {
        setAuthState({
          token: null,
          isAuthenticated: false,
          isLoading: false,
          error: 'لطفاً ابتدا وارد سایت شوید',
        });
      }
    } catch (error) {
      setAuthState({
        token: null,
        isAuthenticated: false,
        isLoading: false,
        error: 'خطا در احراز هویت',
      });
    }
  };

  const logout = () => {
    apiService.clearToken();
    setAuthState({
      token: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,
    });
  };

  return {
    ...authState,
    logout,
  };
}
